import React, { Component } from "react";
import * as ReactDOM from "react-dom";

import logo from './logo.svg';
import sitetitle from './Project-Pics/Site_Title.gif'
import './App.css';
import './Project.css'
import { Link } from 'react-router-dom';

/*Project Links*/
import HumeIC from './proj-HumeIC'

/*Project Links*/

class Item extends Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {

    console.log("Hardware Page");
  return (
   
    <div className="App">
      <header className="App-header">
        <div class="parent">
        <div class="div2">
        <Link to='/HumeIC'>  
          <h4>
        Virginia Tech HUME <br></br> 
        Center project For Migrants
        </h4>
        </Link>
        </div>
        <div class="div3">
        <Link to='/'>  
          <h4>Ouroboros Cascade</h4>
        </Link>
        </div>
        <div class="div4">
        <Link to='/'>
          <h4>Juicecord</h4>
        </Link>
          </div>
        <div class="div5">
        <Link to='/'>
          <h4>Unity Game</h4>
        </Link>
          </div>
        <div class="div6">
        <Link to='/'>
          <h4>Just my build</h4>
        </Link>
           </div>
        <div class="div7">
          -
         </div>
        </div>
        
        




      </header>
    </div>
  );
}

}

export default Item;
